/**
 * lhx-video-player.js — UNIONX 23/08/2026
 *
 * PIEZA 3: el reproductor vertical a pantalla completa. Es el corazón de lo que cobra Firework:
 * swipe vertical entre videos 9:16, con el producto comprable encima.
 *
 * Se alimenta de los botones `[data-lhx-rail-item]` que pinta `sections/lhx-video-rail.liquid`.
 *
 * Reglas que este archivo NO puede romper
 * ---------------------------------------
 * 🪤 El home no aprueba las Core Web Vitals. Por eso este archivo se carga DIFERIDO y no crea
 *    nada hasta el primer toque en una portada: sin interacción, coste cero.
 *
 * 🪤 Solo se carga el video VISIBLE. Los vecinos quedan en `preload="none"`. Sin esto, abrir el
 *    reproductor con 12 historias bajaría ~31 MB de una.
 *
 * 🪤 No se agrega al carro un producto con varias variantes: no sabemos qué color/talla quiere el
 *    cliente y meterle el equivocado es peor que mandarlo a la ficha. Con una sola variante sí.
 */
(function () {
  if (window.__lhxPlayer) return;
  window.__lhxPlayer = true;

  var overlay = null;
  var items = [];
  var io = null;
  var pistaEl = null;
  var actual = 0;
  var bloqueo = false;

  function dinero(t) { return t || ''; }

  /**
   * Eventos a GA4. Sin esto no hay forma de saber si el video vende: en dos semanas la pregunta
   * "¿sirvió?" se contesta con datos propios y no con la promesa del proveedor.
   * 🪤 No se asume que gtag exista — el sitio carga GA por app y puede tardar o no estar.
   */
  function evento(nombre, datos) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nombre, datos);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: nombre }, datos));
    } catch (e) { /* la medición jamás debe romper la compra */ }
  }

  function construir(lista, arranque) {
    overlay = document.createElement('div');
    overlay.className = 'lhx-pl';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Videos de producto');

    var cerrar = document.createElement('button');
    cerrar.type = 'button';
    cerrar.className = 'lhx-pl__cerrar';
    cerrar.setAttribute('aria-label', 'Cerrar');
    cerrar.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    cerrar.addEventListener('click', cerrarTodo);
    overlay.appendChild(cerrar);

    var pista = document.createElement('div');
    pista.className = 'lhx-pl__pista';

    lista.forEach(function (d, i) {
      var sl = document.createElement('div');
      sl.className = 'lhx-pl__slide';

      var v = document.createElement('video');
      v.className = 'lhx-pl__video';
      v.src = d.src;
      v.poster = d.poster;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = i === arranque ? 'auto' : 'none';
      v.dataset.titulo = d.titulo;
      sl.appendChild(v);

      /* El producto, encima del video. */
      var ficha = document.createElement('div');
      ficha.className = 'lhx-pl__ficha';

      /* 🪤 Nada de innerHTML con datos del catálogo: título y precios se escriben con
         textContent. Son datos nuestros, pero un título con "<" rompería el marcado y el hábito
         de concatenar HTML es justo el que termina en XSS. */
      var nombre = document.createElement('p');
      nombre.className = 'lhx-pl__nombre';
      nombre.textContent = d.titulo;
      ficha.appendChild(nombre);

      var precios = document.createElement('p');
      precios.className = 'lhx-pl__precios';
      var pAhora = document.createElement('span');
      pAhora.className = 'lhx-pl__precio';
      pAhora.textContent = dinero(d.precio);
      precios.appendChild(pAhora);
      if (d.comparado) {
        var pAntes = document.createElement('s');
        pAntes.className = 'lhx-pl__antes';
        pAntes.textContent = dinero(d.comparado);
        precios.appendChild(document.createTextNode(' '));
        precios.appendChild(pAntes);
      }
      ficha.appendChild(precios);

      var acciones = document.createElement('div');
      acciones.className = 'lhx-pl__acciones';

      var ver = document.createElement('a');
      ver.className = 'lhx-pl__btn lhx-pl__btn--fantasma';
      ver.href = d.url;
      ver.textContent = 'Ver producto';
      ver.addEventListener('click', function () {
        evento('lhx_video_ver_producto', { lhx_producto: d.titulo });
      });
      acciones.appendChild(ver);

      /* 🪤 Solo se ofrece "Agregar" cuando hay UNA variante. Con varias, el color o la talla
         serían una adivinanza y el cliente se lleva lo que no pidió. */
      if (d.variantes === 1 && d.disponible === '1') {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'lhx-pl__btn lhx-pl__btn--solido';
        add.textContent = 'Agregar';
        add.addEventListener('click', function () {
          evento('lhx_video_agregar', { lhx_producto: d.titulo, lhx_variante: d.variante });
          agregar(d.variante, add);
        });
        acciones.appendChild(add);
      }

      ficha.appendChild(acciones);
      sl.appendChild(ficha);
      pista.appendChild(sl);
      items.push(v);
    });

    overlay.appendChild(pista);
    pistaEl = pista;

    /* Controles explícitos: sin esto, en escritorio el reproductor se siente trabado. */
    var nav = document.createElement('div');
    nav.className = 'lhx-pl__nav';
    var mkBtn = function (clase, etiqueta, delta, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lhx-pl__nav-btn ' + clase;
      b.setAttribute('aria-label', etiqueta);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function () { irA(actual + delta); });
      return b;
    };
    nav.appendChild(mkBtn('lhx-pl__nav--ant', 'Video anterior', -1, 'M18 15l-6-6-6 6'));
    var cta = document.createElement('span');
    cta.className = 'lhx-pl__contador';
    nav.appendChild(cta);
    nav.appendChild(mkBtn('lhx-pl__nav--sig', 'Video siguiente', 1, 'M6 9l6 6 6-6'));
    overlay.appendChild(nav);

    pista.addEventListener('wheel', alaRueda, { passive: false });

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    /* Solo reproduce lo que se ve; lo demás se pausa y no se descarga. */
    io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            actual = [].indexOf.call(pistaEl.children, e.target);
            pintarNav();
            if (!v.dataset.contado) {
              v.dataset.contado = '1';
              evento('lhx_video_ver', { lhx_producto: v.dataset.titulo || '' });
            }
          } else {
            v.pause();
          }
        });
      },
      { root: pista, threshold: 0.6 }
    );
    [].forEach.call(pista.children, function (s) { io.observe(s); });

    evento('lhx_video_abrir', { lhx_producto: lista[arranque].titulo, lhx_posicion: arranque + 1, lhx_total: lista.length });
    actual = arranque;
    pista.children[arranque].scrollIntoView({ block: 'start', behavior: 'instant' });
    pintarNav();
    cerrar.focus();
    document.addEventListener('keydown', alTeclado);
  }

  /**
   * 🪤 Con `scroll-snap-type: y mandatory` + `scroll-snap-stop: always`, un tic de rueda de mouse
   * no alcanza el umbral del snap y el navegador DEVUELVE al mismo video: en escritorio parecía
   * que el reproductor no dejaba pasar al siguiente. Con el dedo sí funciona, por eso solo se veía
   * en escritorio. La salida es dar navegación explícita: flechas, teclado y un paso por gesto de
   * rueda. El swipe táctil nativo se deja intacto.
   */
  function irA(i) {
    if (!pistaEl) return;
    var n = pistaEl.children.length;
    if (i < 0 || i >= n) return;
    actual = i;
    pistaEl.children[i].scrollIntoView({ block: 'start', behavior: 'smooth' });
    pintarNav();
  }

  function pintarNav() {
    if (!overlay) return;
    var n = pistaEl ? pistaEl.children.length : 0;
    var ant = overlay.querySelector('.lhx-pl__nav--ant');
    var sig = overlay.querySelector('.lhx-pl__nav--sig');
    var cta = overlay.querySelector('.lhx-pl__contador');
    if (ant) ant.disabled = actual <= 0;
    if (sig) sig.disabled = actual >= n - 1;
    if (cta) cta.textContent = (actual + 1) + ' / ' + n;
  }

  function alTeclado(e) {
    if (e.key === 'Escape') return cerrarTodo();
    if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') { e.preventDefault(); irA(actual + 1); }
    if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); irA(actual - 1); }
  }

  function alaRueda(e) {
    if (Math.abs(e.deltaY) < 4) return;
    e.preventDefault();
    if (bloqueo) return;
    bloqueo = true;
    irA(actual + (e.deltaY > 0 ? 1 : -1));
    setTimeout(function () { bloqueo = false; }, 450);
  }

  function cerrarTodo() {
    if (!overlay) return;
    items.forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
    if (io) io.disconnect();
    document.removeEventListener('keydown', alTeclado);
    if (pistaEl) pistaEl.removeEventListener('wheel', alaRueda);
    overlay.remove();
    overlay = null;
    items = [];
    io = null;
    pistaEl = null;
    actual = 0;
    bloqueo = false;
    document.body.style.overflow = '';
  }

  function agregar(idVariante, boton) {
    var texto = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Agregando…';
    var ruta = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(idVariante), quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        boton.textContent = 'Agregado ✓';
        /* Refrescar el contador del carro del tema sin recargar la página. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { boton.textContent = texto; boton.disabled = false; }, 2200);
      })
      .catch(function () {
        boton.textContent = 'No se pudo';
        setTimeout(function () { boton.textContent = texto; boton.disabled = false; }, 2200);
      });
  }

  function abrir(desde) {
    var botones = [].slice.call(document.querySelectorAll('[data-lhx-rail-item]'));
    var lista = botones.map(function (b) {
      return {
        src: b.dataset.src,
        poster: b.dataset.poster,
        titulo: b.dataset.titulo,
        precio: b.dataset.precio,
        comparado: b.dataset.comparado,
        url: b.dataset.url,
        variante: b.dataset.variante,
        variantes: Number(b.dataset.variantes),
        disponible: b.dataset.disponible,
      };
    });
    construir(lista, botones.indexOf(desde));
  }

  /* 🪤 Esto NO es un <dialog>: el botón atrás de Android navega de verdad y no lo congela.
     Pero Chrome guarda la página en el bfcache TAL CUAL, y al volver atrás reaparece el
     reproductor abierto, con `body` en overflow:hidden y los videos cargados gastando datos.
     Cerrarlo al salir deja la página limpia para la vuelta. `pagehide` es el único evento que
     dispara en móvil tanto al navegar como al mandar la pestaña al bfcache: `unload` no corre
     y `beforeunload` descalifica la página del bfcache. (31/08/2026) */
  window.addEventListener('pagehide', function () { cerrarTodo(); });

  /* Delegación: un solo listener para todo el rail, y sirve también para lo que se repinte. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lhx-rail-item]');
    if (!b) return;
    e.preventDefault();
    abrir(b);
  });
})();
